"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.APIUtils = exports.APIRegistry = void 0;
var _registry = _interopRequireDefault(require("./registry"));
const APIRegistry = exports.APIRegistry = new _registry.default();
const APIUtils = exports.APIUtils = APIRegistry.get('default');
var _default = exports.default = APIUtils;